<template>
  <div>
    <page-content-toolbar
      :projectName="$t('global.search')"
      title=""
    />

    <v-container
      fluid
      class="px-11 pt-3 mb-12"
    >
      <v-row
        no-gutters
        justify="start"
        class="elevation-1 px-4 mx-2 py-4 my-5 grey lighten-2"
      >
        <v-col cols="12">
          <h3 class="pa-3">{{ $t('global.searchProjectsByNameOrUserOrAccount') }} :</h3>
        </v-col>
        <v-col cols="12">
          <v-text-field
            v-model="searchField"
            class="white rai-input-element"
            @keyup.enter="search"
            autofocus
            outlined
            :label="$t('global.typeKeyWord')"
          />
        </v-col>
      </v-row>
      <v-row no-gutters justify="center">
        <v-col cols="1">
          <raison-button
            :button-label="$t('global.validate')"
            :button-function="search"
            :disabled="searchField === ''"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PageContentToolbar from '@/components/layout/PageContentToolbar';
import RaisonButton from '@/components/global/RaisonButton';

export default {
  name: 'SearchPage',

  components: { PageContentToolbar, RaisonButton },

  data () {
    return {
      searchField: '',
    };
  },

  methods: {
    search () {
      if (this.searchField !== '') {
        this.$router.push({ name: 'searchProjects', params: { query: this.searchField} });
      }
    },
  },
};
</script>